import apiClient from '@/Services/Clients/apiClient';

const CAMERA_BASE_URL: string = 'api/camera';
class CameraService {

  /**
   * @param {string} cameraId
   * @return {Promise}
   */
  public static getCamera(cameraId: string) {

    const resourceUrl = `${CAMERA_BASE_URL}/${cameraId}`;
    return apiClient.get(resourceUrl);
  }

  /**
   * @param {object} cameraData
   * @return {Promise}
   */
  public static updateCamera(cameraData) {

    const resourceUrl = `${CAMERA_BASE_URL}/${cameraData.cameraId}`;
    return apiClient.put(resourceUrl, cameraData);
  }

  /**
   * @param {object} cameraData
   * @return {Promise}
   */
  public static addNewCamera(cameraData) {
    return apiClient.post(CAMERA_BASE_URL, cameraData);
  }

  /**
   * @param {string} cameraId
   * @return {Promise}
   */
  public static deleteCamera(cameraId: string) {
    const resourceUrl = `${CAMERA_BASE_URL}/${cameraId}`;
    return apiClient.delete(resourceUrl);
  }
}

export default CameraService;
